// Klávesnice na dotykovém zařízení (W85, hlášení zadavatele 31. 10. 2026 z ostrého tabletu — Vážení › 1. vážení na
// výšku s otevřenou klávesnicí): Android s `interactive-widget=resizes-content` (index.html) okno zmenší o klávesnici,
// spodní lišta aplikace se při psaní schová (Shell.css), ale přichycené pruhy s tlačítky (`position: sticky; bottom`)
// zůstaly o výšku lišty nad klávesnicí a spolu s přichyceným panelem váhy nahoře zakrývaly vyplňované pole i jeho
// nabídku.
//
// Společné pravidlo: když je fokus v textovém poli na dotykovém zařízení (`pointer: coarse` — tam se otevře
// klávesnice), dostane `<html>` atribut `data-klavesnice`. Styly sekcí pak přichycené pruhy a panely vrátí do toku
// stránky (`:root[data-klavesnice] … { position: static }`), takže nic nepřekrývá pole, do kterého se píše. Po odchodu
// z pole se atribut s malým zpožděním odebere — přechod z pole do pole (Tab, Další na klávesnici) nebliká.
export const ATRIBUT_KLAVESNICE = 'data-klavesnice';

/** Jak dlouho po odchodu z pole se čeká, než se pruhy zase přichytí (přechod do dalšího pole). */
export const PRODLEVA_ZAVRENI_MS = 250;

/** Typy `<input>`, u kterých se klávesnice neotevře. */
const BEZ_KLAVESNICE = new Set([
  'checkbox',
  'radio',
  'button',
  'submit',
  'reset',
  'file',
  'range',
  'color',
  'image',
  'hidden',
]);

/** Otevře prvek na dotykovém zařízení klávesnici (textové pole, textarea, editovatelný obsah)? */
export function jePsaciPole(prvek: Element | null): boolean {
  if (!prvek) return false;
  if (prvek instanceof HTMLTextAreaElement) return !prvek.readOnly && !prvek.disabled;
  if (prvek instanceof HTMLInputElement) {
    return !BEZ_KLAVESNICE.has(prvek.type) && !prvek.readOnly && !prvek.disabled;
  }
  return prvek instanceof HTMLElement && prvek.isContentEditable === true;
}

function jeDotyk(okno: Window): boolean {
  return typeof okno.matchMedia === 'function' && okno.matchMedia('(pointer: coarse)').matches;
}

/** Začne sledovat fokus a nastavovat `data-klavesnice` na `<html>`; vrací funkci, která sledování ukončí. */
export function sledovatKlavesnici(okno: Window = window): () => void {
  const html = okno.document.documentElement;
  let casovac: ReturnType<typeof setTimeout> | undefined;

  const nastavit = () => {
    const pise = jeDotyk(okno) && jePsaciPole(okno.document.activeElement);
    if (pise) html.setAttribute(ATRIBUT_KLAVESNICE, '');
    else html.removeAttribute(ATRIBUT_KLAVESNICE);
  };
  const priFokusu = () => {
    clearTimeout(casovac);
    nastavit();
  };
  const priOdchodu = () => {
    clearTimeout(casovac);
    casovac = setTimeout(nastavit, PRODLEVA_ZAVRENI_MS);
  };

  okno.document.addEventListener('focusin', priFokusu);
  okno.document.addEventListener('focusout', priOdchodu);
  nastavit();
  return () => {
    clearTimeout(casovac);
    okno.document.removeEventListener('focusin', priFokusu);
    okno.document.removeEventListener('focusout', priOdchodu);
    html.removeAttribute(ATRIBUT_KLAVESNICE);
  };
}
